// =====================================================
// SMART CHECKOUT JAVASCRIPT
// Für den aktuellen Custom Checkout
// =====================================================

// Import Checkout-spezifische Styles
import '../sass/shop/checkout.scss';

// Import jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// Import Smart Checkout Logik
import '../js/smart-checkout';

// Import Address Manager
import '../js/address-manager';

// Import modern Checkout logic (vormals in main.js)
import './js/checkout';

// Vite Hot Module Replacement
if (import.meta.hot) {
  import.meta.hot.accept();
}

if (typeof window !== 'undefined') {
  window.__VS_BUILD_SMART__ = 'smart-' + new Date().toISOString();
  console.log('[VS] smart checkout bundle loaded:', window.__VS_BUILD_SMART__);
}
